import { render, staticRenderFns } from "./SimplingDetails.vue?vue&type=template&id=aa6a8170&scoped=true&"
import script from "./SimplingDetails.vue?vue&type=script&lang=js&"
export * from "./SimplingDetails.vue?vue&type=script&lang=js&"
import style0 from "./SimplingDetails.vue?vue&type=style&index=0&id=aa6a8170&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6a8170",
  null
  
)

export default component.exports